<template>
  <div class="GoogleFormWrapper">
    <iframe
      :scrolling="isScrollingEnabled"
      :src="formSrc"
      title="">
      Įkeliama…
    </iframe>
    <Font class="consent" fontface="Verdana" size="1">
      Pildydami laukelius, sutinkate, kad UAB „Nogridas“ <a href="https://nogrid.lt/privatumo-politika" target="_blank" title="">
        tvarkys šiuos duomenis
      </a> komerciniais tikslais.
    </Font>
  </div>
</template>

<script>
import { getters } from 'views/utils'

export default {
  props: {
    formSrc: String,
    isAlwaysScrollable: {
      type: Boolean,
      default: false,
    },
  },
  data() { return { windowHeight: window.innerHeight } },
  computed: {
    isScrollingEnabled() {
      if (this.isAlwaysScrollable) return 'yes'
      if (this.vh < 510) return 'yes'
      return this.screenSizes.includes('md') ? 'no' : 'yes'
    },
    vh() {
      return this.windowHeight || 0
    },
    ...getters('screenSizes'),
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowHeight = window.innerHeight
    })
  },
}
</script>

<style lang="scss">
.GoogleFormWrapper {
  background: $white;
  display: block;
  width: 100%;
  @include md {
    // padding-top: 2rem;
  }

  .consent {
    display: inline-block;
    text-align: center;
    width: 100%;
  }
}
</style>
